<template>
  <div class="magicstone-scan-page">
    <img class="logo" src="/static/images/magicstone/ms-logo.png" />
    <div class="scan-text">点击按钮扫码查询</div>
    <img class="scan-img" src="/static/images/magicstone/scan.png" @click="handleScan" />
    <div class="tip-text">若条形码破损请输入数码查询</div>
    <div class="query-container">
      <div class="query-box">
        <input type="text" v-model="antiCode" placeholder="输入16位数码进行查询" maxlength="16" class="query-input" />
        <button @click="queryAnti" class="query-button">查询</button>
      </div>
    </div>
  </div>
</template>

<style scoped>
.magicstone-scan-page {
  width: 100vw;
  height: 100vh;
  background-color: rgb(175, 244, 39);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: auto;
  position: relative;
}

.logo {
  margin-top: 7vh;
  width: 30vw;
  height: auto;
}

.scan-text {
  margin-top: 5vh;
  font-size: 6.2vw;
  letter-spacing: 2vw;
}

.scan-img {
  margin-top: 8vh;
  width: 40vw;
  height: auto;
}

.tip-text {
  margin-top: 4vh;
  color: black;
  font-size: 4.2vw;
}

.query-container {
  margin-top: 2.5vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.query-box {
  display: flex;
  width: 76vw;
  overflow: hidden;
  border-radius: 0;
}

.query-input {
  flex: 1;
  height: 6vh;
  border: 1.5px solid black;
  border-right: none;
  padding: 0 3vw;
  font-size: 4vw;
  background: white;
  color: #333;
  outline: none;
  border-radius: 0;
  -webkit-appearance: none;
}

.query-button {
  width: 20vw;
  height: 6vh;
  background: black;
  color: white;
  border: none;
  font-size: 4.5vw;
  font-weight: bold;
  cursor: pointer;
  outline: none;
}
</style>

<script>
import { getJSSDK } from '../../api/api'
import wx from 'weixin-js-sdk'

export default {
  name: 'MagicStoneScan',
  data() {
    return {
      antiCode: '',
      appId: process.env.ENV_NUM === '1' ? 'wx22242a811779ec8c' : 'wxbc22565b3e7a59fd'
    }
  },
  methods: {
    handleScan() {
      wx.scanQRCode({
        needResult: 1,
        scanType: ["barCode"],
        success: res => {
          var scanResult = res.resultStr
          var scanQRCode = scanResult
          if (scanResult.startsWith('http')) {
            let parts = scanResult.split('/');
            scanQRCode = parts.length > 0 ? parts[parts.length - 1] : ''
            scanQRCode = scanQRCode.substring(0, 16)
          }else{
            scanQRCode = scanQRCode.replaceAll('CODE_128,', '')
          }
          this.antiCode = scanQRCode
          this.$router.push({
            path: '/magicstone',
            query: {
              c: this.antiCode
            }
          });
        }
      });
    },
    queryAnti() {
      if (this.antiCode == '' || this.antiCode.length != 16) {
        alert('请输入16位防伪码进行查询验证')
      } else {
        this.$router.push({
          path: '/magicstone',
          query: {
            c: this.antiCode
          }
        })
      }
    },
    getWxJs() {
      const url = encodeURIComponent(window.location.href.split('#')[0])
      getJSSDK(url, this.appId).then(res => {
        const data = res.data.data
        wx.config({
          debug: false,
          appId: data.appId,
          timestamp: data.timestamp,
          nonceStr: data.nonceStr,
          signature: data.signature,
          openTagList: ["wx-open-launch-weapp", "wx-open-launch-app"],
          jsApiList: [
            'checkJsApi',
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'onMenuShareQQ',
            'onMenuShareWeibo',
            'onMenuShareQZone',
            'hideMenuItems',
            'showMenuItems',
            'hideAllNonBaseMenuItem',
            'showAllNonBaseMenuItem',
            'translateVoice',
            'startRecord',
            'stopRecord',
            'onVoiceRecordEnd',
            'playVoice',
            'onVoicePlayEnd',
            'pauseVoice',
            'stopVoice',
            'uploadVoice',
            'downloadVoice',
            'chooseimg',
            'predivimg',
            'uploadimg',
            'downloadimg',
            'getNetworkType',
            'openLocation',
            'getLocation',
            'hideOptionMenu',
            'showOptionMenu',
            'closeWindow',
            'scanQRCode',
            'chooseWXPay',
            'openProductSpecificdiv',
            'addCard',
            'chooseCard',
            'openCard'
          ]
        });
        wx.ready(function () {
          wx.hideMenuItems({
            menuList: [
              'menuItem:copyUrl',
              'menuItem:openWithQQBrowse',
              'menuItem:openWithSafari',
              'menuItem:email',
              'menuItem:readMode',
              'menuItem:originPage',
              'menuItem:delete',
              'menuItem:editTag'
            ]
          });
        });
      }).catch(err =>
        alert("获取微信授权失败" + err)
      )
    }
  },
  mounted() {
    this.getWxJs()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/MagicStone/Scan.vue